// True when a project's searchCategory is the bulk-upload category.
// Compared against the literal token (not UI_OPTIONS[...].Bulk) because that
// picker option is env-gated (non-prod only) while this recognition must hold
// in every environment, including prod.
export const isBulkSearchProject = (searchCategory) => searchCategory === 'companyBulkSearch';

// Criteria-panel copy for a bulk search. A bulk search has no criteria to show,
// so we render the source file name instead. Never touches project.fields
// (bulk projects carry no mapped `fields`, see ProfilerProjectsStore).
export const bulkSearchCriteriaText = (project = {}) =>
  project?.sourceFileName
    ? `User executed a bulk search – ${project.sourceFileName}`
    : 'User executed a bulk search';
